import React from 'react';
import { Link } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Layout, Dropdown, Avatar } from 'antd';
import { DownOutlined, SettingOutlined, LogoutOutlined, UpOutlined } from '@ant-design/icons';

import logoSrc from '../../../assets/images/logo-full-transparent.webp';
import { AppDispatch, CombinedStates } from '../../../core/types';
import { UserIcon } from '../../Elements/CustomSVGIcon';
import Menu from '../Menu';
import type { HeaderProps } from './types';
import { logoutUser } from '../../../core/user/userApi';
import { roleOptions } from '../../../core/utils/helpers';
import './header.css';

const Header = (props:HeaderProps) => {
    const {
        // uncomment this if you want to use toolbar
        // toolbar,
        menu,
        backLink,
        title,
        menuPlacement,
        menuWidth,
        floating,
        beforeHeader,
        afterHeader,
        isPublic,
    } = props;

    const dispatch = useDispatch<AppDispatch>();

    const {
        userData,
    } = useSelector((state:CombinedStates) => state.user);

    const handleLogout = () => {
        dispatch(logoutUser());
    };

    const items:MenuProps['items'] = [
        { label: (<Link to="/profilio-nustatymai"><SettingOutlined /> Profilio nustatymai</Link>), key: 'settings' },
        { label: (<span><LogoutOutlined /> Atsijungti</span>), key: 'logout', onClick: handleLogout },
    ];

    // (
    //     <Col>
    //         <img src={logoSrc} alt="logo" className="header-logo" />
    //     </Col>
    // )

    return (
        <div className={`header ${floating ? 'floating-header' : ''}`}>
            {beforeHeader}
            <Layout.Header className="header__inner">
                <Row justify="space-between" align="middle" style={{ height: 'inherit' }}>
                    <Col>
                        <Row align="middle">
                            {!isPublic && (
                                <Col className="header-menu-container">
                                    {menu ? <Menu items={menu} placement={menuPlacement} width={menuWidth} /> : null}
                                </Col>
                            )}
                            {
                                backLink ? (
                                    <Col>
                                        {backLink}
                                    </Col>
                                ) : null
                            }
                        </Row>
                    </Col>
                    <Col>
                        <h3 className="header__title h-4">{title}</h3>
                    </Col>
                    {/*
                    // uncomment this if you want to use toolbar
                    <Col>
                        <div className="d-flex justify-content-end">
                            {toolbar.map((button, buttonIndex) => (
                                <Button
                                    key={button.id || buttonIndex}
                                    size={button.size || 'default'}
                                    className="toolbar-button"
                                    href={button.link || '#'}
                                    onClick={button.onClick || null}>

                                    <span>{button.label}</span>
                                </Button>
                            ))}
                        </div>
                    </Col> */
                    }
                    <Col>
                        {!isPublic && (
                            <Dropdown arrow menu={{ items }} trigger={['click']} placement="bottomRight">
                                <div className="avatar-menu-wrapper">
                                    <Avatar className="header__avatar" icon={<UserIcon />} />
                                    <span className="avatar-name">{userData?.first_name}<br /><span className="avatar-role">{roleOptions.find(r => r.id === userData?.role_id)?.name}</span></span>
                                    <DownOutlined />
                                    <UpOutlined />

                                </div>
                            </Dropdown>
                        )}
                    </Col>
                </Row>
            </Layout.Header>
            {afterHeader}
        </div>
    );
};

Header.defaultProps = {
    logo: '',
    beforeHeader: null,
    afterHeader: null,
    menu: [],
    isPublic: false,
};

export default Header;
